﻿import {Ref, unref} from "vue";
import {AccessToken} from "./types";
import {useMateApi} from "./useMateApi";
import {DocumentType} from "./useDocumentApi";

export interface ExampleDocumentHeader {
    id: string;
    name: string;
}

export interface DocumentHeader {
    uid: string;
    id: string;
    date: Date;
    amount: number;
    currency: string;
    name?: undefined;
}

export const convertToDocumentHeader = (r: any): DocumentHeader => ({
    uid: r.Uid,
    id: r.Id,
    date: r.LocalClosedAt,
    amount: r.AmountGross,
    currency: r.Currency,
});

export const useReceiptApi = (documentType: string | Ref<DocumentType>, tenantOid: number | Ref<number>, accessToken: AccessToken) => {

    const {baseUrl, jsonEndpoint, xmlEndpoint} = useMateApi(accessToken, tenantOid)
    const jsonApi = jsonEndpoint("/api");
    const xmlApi = xmlEndpoint("/api");

    const getBlocks = () =>
        jsonApi.get({}, {url: `/blockly/documents/${unref(documentType)}/blocks`});

    const getLogoIds = () =>
        jsonApi.get({}, {url: "/blockly/options/logo-ids"});

    const getToolbox = () =>
        xmlApi.get({}, {url: `/blockly/documents/${unref(documentType)}/toolbox`});

    const getTemplate = () =>
        xmlApi.get({}, {url: `/templates/documents/${unref(documentType)}`});

    // const setTemplate = (xmlStr: string) =>
    //     xmlApi
    //         .put(xmlStr, {}, {url: `/templates/documents/${unref(documentType)}`, headers: {"Content-Type": "application/xml"}})
    //         // send same xml back, may in the future, we include version, etc....
    //         .then(result => xmlStr);

    const setTemplate = (xmlStr: string) =>
        new Promise<string>((resolve, reject) => {
            const url = `/templates/documents/${unref(documentType)}`;
            const headers = {"Content-Type": "application/xml"};
            xmlApi
                .put(xmlStr, {}, {url, headers})
                .then(result => resolve(xmlStr))
                .catch(error => {
                    if (error.httpStatus === 404) {
                        xmlApi
                            .post(xmlStr, {}, {url, headers})
                            .then(result => resolve(xmlStr))
                            .catch(reject);
                    } else {
                        reject(error);
                    }
                });
        });

    const getExampleDocumentHeaders = (): Promise<ExampleDocumentHeader[]> =>
        jsonApi.get({}, {url: `/documents/examples/${unref(documentType)}`})
            .then(dict => Object.keys(dict).map(key => ({id: key, name: dict[key]})));

    const getPreview = (blocklyXml: string, options: any) => {
        const formData = new FormData();
        formData.append("Xml", blocklyXml);
        formData.append("Options", JSON.stringify(options));
        return xmlApi.post(formData, {}, {url: `/blockly/documents/${unref(documentType)}/preview`});
    };

    return {
        baseUrl,
        getBlocks,
        getLogoIds,
        getToolbox,
        getPreview,
        getTemplate,
        setTemplate,
        getExampleDocumentHeaders
    }
}